import { render, staticRenderFns } from "./AdminBulkAddUser.vue?vue&type=template&id=0b0e8bc5&scoped=true&"
import script from "./AdminBulkAddUser.vue?vue&type=script&lang=js&"
export * from "./AdminBulkAddUser.vue?vue&type=script&lang=js&"
import style0 from "./AdminBulkAddUser.vue?vue&type=style&index=0&id=0b0e8bc5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0e8bc5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b0e8bc5')) {
      api.createRecord('0b0e8bc5', component.options)
    } else {
      api.reload('0b0e8bc5', component.options)
    }
    module.hot.accept("./AdminBulkAddUser.vue?vue&type=template&id=0b0e8bc5&scoped=true&", function () {
      api.rerender('0b0e8bc5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/AdminBulkAddUser.vue"
export default component.exports